import { render } from "./Home.vue?vue&type=template&id=af8b3782&lang=pug"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=af8b3782&lang=stylus"
script.render = render

export default script